// extracted by mini-css-extract-plugin
export default {"ItemIcon":"RefItem-module__ItemIcon--Ss18O"};